import React, { useEffect, useMemo, useState } from "react";
import { View, StyleSheet } from "react-native";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import NtText from "../../components/NtText";
import { useTheme } from "../../context/ThemeContext";
import destinationactiondata from "../data/destinationactiondata";

/**
 * Inline display for a destination action — shows the action type alongside
 * its value. Visually distinct from NtExtensionTag so an extension *value*
 * and an action targeting an extension read differently.
 *
 * Layout: left tinted icon square (brand2 glyph) | action title (muted) |
 * thin separator | the value in body text.
 */
function NtAccountDisplay({ item }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const [action, setAction] = useState(null);

  useEffect(() => {
    const match = destinationactiondata?.find((each) => each.id == item?.name);
    setAction(
      match || (item?.name ? { icon: "dots-horizontal", title: item.name } : null)
    );
  }, [item?.name]);

  if (!action) return null;

  return (
    <View style={styles.container}>
      <View style={styles.iconBox}>
        <NtMaterialIcon name={action.icon} color={theme.brand2} size={12} />
      </View>
      <NtText style={styles.label}>{action.title}</NtText>
      {item?.value ? (
        <>
          <View style={styles.separator} />
          <NtText style={styles.value}>{item.value}</NtText>
        </>
      ) : null}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      flexDirection: "row",
      alignItems: "center",
      alignSelf: "flex-start",
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radius,
      paddingRight: 9,
      gap: 8,
      overflow: "hidden",
    },
    iconBox: {
      width: 22,
      height: 22,
      backgroundColor: t.pillBg,
      borderRightWidth: 1,
      borderRightColor: t.borderSoft,
      alignItems: "center",
      justifyContent: "center",
    },
    label: {
      color: t.textDim,
      fontSize: 11,
      fontWeight: "500",
    },
    separator: {
      width: 1,
      height: 10,
      backgroundColor: t.borderSoft,
    },
    value: {
      color: t.text,
      fontSize: 12,
      fontWeight: "600",
    },
  });

export default NtAccountDisplay;
